import React, { useEffect } from "react";
import { NavLink, Outlet } from "react-router-dom";

const AdminDashboard = () => {
  useEffect(() => {
    const wrap = document.querySelector(".header-wrapper");
    if (!wrap) return;

    const sync = () => {
      const bottom = Math.ceil(wrap.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty(
        "--shell-fixed-stack-bottom",
        `${bottom}px`,
      );
    };

    sync();
    const ro = new ResizeObserver(() => requestAnimationFrame(sync));
    ro.observe(wrap);
    return () => ro.disconnect();
  }, []);
  const sidebarAdmin = [
    { Title: "לקוחות", Link: "/admin/users", Img: "clients.svg" },
    { Title: "הזמנות", Link: "/admin/history", Img: "cart.svg" },
    { Title: "פריטים", Link: "/admin/products", Img: "related-products.svg" },
    { Title: "מחלקות", Link: "/admin/category-edit", Img: "list.svg" },
    { Title: "מסננים", Link: "/admin/filters", Img: "filter.svg" },
    /*{
      Title: "יצירת מחסן",
      Link: "/admin/station",
      Img: "location.svg",
    },*/
    {
      Title: "מבצעים",
      Link: "/admin/sales-management",
      Img: "notifications.svg",
    },
    {
      Title: "השוואת מחירים",
      Link: "/admin/price-compare",
      Img: "bar_chart.svg",
    },
    { Title: "קופונים", Link: "/admin/coupons" },
    {
      Title: "הגדרות משלוח",
      Link: "/admin/delivery-edit",
      Img: "settings.svg",
    },
  ];

  return (
    <div className="admin-dashboard">
      <div className="admin-dashboard__tabs">
        {sidebarAdmin.map((element, index) => (
          <NavLink to={element.Link} className="tab" key={index}>
            <span>{element.Title}</span>
          </NavLink>
        ))}
      </div>
      <div className="admin-dashboard__spacer" aria-hidden="true" />
      <div className="admin-dashboard__outlet">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminDashboard;
